/* IMPORTANT: This file is auto-generated. Do not modify it directly or changes will be lost. */
if (window.location.hash == "#cart") {
  let cartDrawer = document.querySelector("cart-drawer");
  cartDrawer.setAttribute("open", "");
}

class BundleOffers extends HTMLElement {
  connectedCallback() {
    this.formId = this.dataset.formId;
    this.form = this.formId ? document.getElementById(this.formId) : null;

    if (!this.form) {
      return;
    }

    this.offerButtons = Array.from(this.querySelectorAll("[data-bundle-offer]"));
    if (!this.offerButtons.length) {
      return;
    }

    this.idInput = this.form.querySelector('input[name="id"]');
    this.quantityInput = this.form.querySelector('input[name="quantity"]');

    if (!this.quantityInput) {
      this.quantityInput = document.createElement("input");
      this.quantityInput.type = "hidden";
      this.quantityInput.name = "quantity";
      this.quantityInput.value = "1";
      this.form.appendChild(this.quantityInput);
    }

    this.offerButtons.forEach((button) => {
      button.addEventListener("click", () => this.selectOffer(button));
    });

    const selectedButton = this.offerButtons.find((button) => button.classList.contains("is-selected")) || this.offerButtons[0];
    this.selectOffer(selectedButton);
  }

  selectOffer(button) {
    if (!button) {
      return;
    }

    this.offerButtons.forEach((item) => {
      const isSelected = item === button;
      item.classList.toggle("is-selected", isSelected);
      item.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    const variantId = button.dataset.offerVariantId;
    const quantity = button.dataset.offerQuantity;

    if (this.idInput && variantId) {
      this.idInput.value = variantId;
    }

    if (this.quantityInput && quantity) {
      this.quantityInput.value = quantity;
    }

    this.syncDisplayedPrices(button);
  }

  syncDisplayedPrices(button) {
    const price = button.dataset.offerPrice || "";
    const compareAtPrice = button.dataset.offerCompareAtPrice || "";
    const scope = this.closest(".shopify-section--main-product") || document;
    const priceLists = Array.from(scope.querySelectorAll(".price-list"));

    priceLists.forEach((list) => {
      const salePriceNode = list.querySelector("sale-price");
      const compareAtPriceNode = list.querySelector("compare-at-price");

      if (salePriceNode) {
        salePriceNode.textContent = price;
      }

      if (compareAtPriceNode) {
        compareAtPriceNode.textContent = compareAtPrice;
      }
    });

    const ctaPriceNodes = Array.from(scope.querySelectorAll(".buy-buttons__prices .price"));
    ctaPriceNodes.forEach((node) => {
      node.textContent = price;
    });

    const ctaCompareNodes = Array.from(scope.querySelectorAll(".buy-buttons__prices .compare-at-price"));
    ctaCompareNodes.forEach((node) => {
      node.textContent = compareAtPrice;
    });
  }
}

if (!window.customElements.get("bundle-offers")) {
  window.customElements.define("bundle-offers", BundleOffers);
}